import { useEffect, useState } from 'react'
import { useParams, useSearchParams } from 'react-router-dom'

import DotsSvg from '../../../../assets/img/dots.svg'
import Avatar from '../../../../assets/img/user-1.png'
import User from '../../../../assets/img/user-photo-3.png'
import Dropdown from '../../../../compoments/common/Dropdown'
import Image from '../../../../compoments/common/Image'
import UsersGroup from '../../../../compoments/common/UsersGroup'
import DropdownList from '../../../../compoments/DropdownList'
import PageLoader from '../../../../compoments/PageLoader'
import {
    useGetGroupHeaderQuery,
    useGetGroupSchedulesQuery,
} from '../../../../services/tenant/workGroups'
import { getMediaUrl, getStartAndEndOfDay } from '../../../../utils/helpers'

import Statistics from './Statistics'
import { TaskList } from './TaskList'
import { TeamList } from './TeamList'
import { WorkingSchedule } from './WorkingSchedule'
import AddWorkGroupModal from '@/compoments/modals/AddWorkGroupModal'

export const AdminWorkGroupPage = () => {
    const { id } = useParams()
    const [searchParams] = useSearchParams()
    const { data, isLoading } = useGetGroupHeaderQuery(Number(id), {
        skip: !id,
    })

    const pageData = data?.data
    console.log(pageData)

    const tabs = [
        {
            name: 'Working Schedule',
            id: 1,
        },
        {
            name: 'Task List',
            id: 2,
        },
        {
            name: 'Team List',
            id: 3,
        },
        {
            name: 'Statistics',
            id: 4,
        },
    ]
    const [activeTab, setActiveTab] = useState(tabs[0].id)
    if (isLoading) return <PageLoader />

    return (
        <main className="content flex flex-col">
            <div className="px-container flex flex-col flex-auto">
                <div className="card-user-info mb-18">
                    <div className="card-user-info__item flex items-center gap-18">
                        <div className="user-photo-60x60">
                            <Image
                                src={getMediaUrl(pageData?.executive?.photo)}
                            />
                        </div>

                        <div className="flex flex-col">
                            <span className="text--xs text-color-1">
                                Executive
                            </span>
                            <h5 className="mb-4px">
                                {pageData?.executive?.fullName
                                    ? pageData?.executive?.fullName
                                    : 'not specified'}
                            </h5>
                        </div>
                    </div>
                    <UsersGroup
                        list={
                            pageData?.randomUsers.map((el) => ({
                                src: el.photo,
                            })) || []
                        }
                        usersCount={pageData?.totalUsers || 0}
                    />

                    {/* <Dropdown
                        closeSelf={true}
                        dropdownClasses="ml-auto"
                        buttonClassName="btn btn--sm btn--outline-primary fullRadius gap-6"
                        button={
                            <>
                                <span className="text--xs">Actions</span>
                                <div className="ico ico-profile-arrow-drp">
                                    <svg
                                        width="14"
                                        height="14"
                                        viewBox="0 0 14 14"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <g>
                                            <path
                                                d="M11.375 5.25L7 9.625L2.625 5.25"
                                                stroke="currentColor"
                                                strokeWidth="1.5"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            ></path>
                                        </g>
                                        <defs>
                                            <clipPath>
                                                <rect
                                                    width="14"
                                                    height="14"
                                                    fill="currentColor"
                                                ></rect>
                                            </clipPath>
                                        </defs>
                                    </svg>
                                </div>
                            </>
                        }
                        menuClassName="dropdown-md"
                        menu={<DropdownList list={[]} />}
                    /> */}
                </div>
                <div className="table-group tabs flex flex-col flex-auto">
                    <div className="table-filter-actions tabs-links-list modal__tabs__body">
                        {tabs &&
                            tabs.map((el, index) => (
                                <button
                                    data-tab-link=""
                                    onClick={() => setActiveTab(el.id)}
                                    className={`btn full-radius btn--xs btn-tab-custom ${activeTab === el.id ? 'active-tab' : ''}`}
                                    key={index}
                                >
                                    <span>{el.name}</span>
                                </button>
                            ))}
                    </div>

                    <div className="tabs-body flex-auto overflow-hidden">
                        {activeTab === 1 && <WorkingSchedule />}
                        {activeTab === 2 && <TaskList />}
                        {activeTab === 3 && <TeamList />}
                        {activeTab === 4 && <Statistics />}
                    </div>
                </div>
            </div>
        </main>
    )
}
